module.exports = __webpack_public_path__ + "img/productBanner.d2bb366a.png";